// extracted by mini-css-extract-plugin
module.exports = {"upcomingEpisode":"CG","comingSoon":"CH","isRental":"CI","startDate":"CJ","upcomingTitle":"CK","status":"CL","comingSoonTitle":"CM","startDateTitle":"CN","available":"CO"};